/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type CartState = 'open' | 'payment_in_progress' | 'payment_started';

export const CartState = {
	Open: 'open' as CartState,
	PaymentInProgress: 'payment_in_progress' as CartState,
	PaymentStarted: 'payment_started' as CartState
};
